<template>
  <div
    class="login_background flex justify-center align-center flex-col items-center h-screen w-full bg-no-repeat bg-right"
    :style="backgroundStyle"
  >
    <div class="flex justify-start flex-col items-center" style="width: 500px">
      <div class="self-center mb-10">
        <logoSvg />
      </div>
      <ProgressBar></ProgressBar>
      <div
        class="w-4 h-0.5 flex-shrink-0 bg-coach-green-500 my-4 self-center"
      ></div>
      <div class="info-form-div text-center">
        <div class="main-body">
          <h2 class="text-3xl font-bold text-black mb-4">
            Never Miss a Client Message
          </h2>

          <p class="text-gray-600 text-lg mb-4">
            Get notified right on your phone whenever a client sends you a
            message. Enter your number and we'll text you a link to download
            the Coach Catalyst coach app.
          </p>

          <div class="hidden sm:flex justify-center send-number-visual">
            <div class="story-background"></div>
          </div>

          <div class="text-left mb-6">
            <label
              for="phone-number"
              class="block text-sm font-medium text-gray-700"
            >Phone Number</label
            >
            <div class="mt-1 relative rounded-md shadow-sm">
              <div class="absolute inset-y-0 left-0 flex items-center">
                <label for="country" class="sr-only">Country</label>
                <vue-country-code
                  @onSelect="
                    ({ dialCode }) => {
                      phoneCode = dialCode;
                    }
                  "
                  :preferredCountries="['US', 'CA', 'GB', 'AU']"
                >
                </vue-country-code>
              </div>
              <input
                v-model="phone"
                type="tel"
                name="phone-number"
                id="phone-number"
                class="focus:ring-green-500 focus:border-green-500 block w-full pl-16 sm:text-sm border-gray-300 rounded-md"
                placeholder="+1 (555) 987-6543"
              />
            </div>
          </div>

          <input
            type="button"
            @click="submit"
            :disabled="!isPhonePlausible || submitting"
            value="Text me the app link"
            class="btn button w-full rounded-lg phone-submit"
          />

          <button
            type="button"
            @click="skip"
            :disabled="submitting"
            class="phone-skip-link block mx-auto mt-4 text-sm text-gray-400 hover:text-gray-600 underline bg-transparent border-0 cursor-pointer"
          >
            I'll do this later
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiUrls from '../../api-url';
import AuthenticationMixin from '../../authentication-mixin';
import ProgressBar from '../shared/progress-bar';
import logoSvg from '../../svgs/logoSvg.vue';

export default {
  name: 'send-your-number',
  components: { ProgressBar, logoSvg },
  mixins: [ApiUrls, AuthenticationMixin],
  data() {
    return {
      phoneCode: 1,
      phone: '',
      submitting: false,
    };
  },
  beforeCreate: function() {
    document.body.style.backgroundColor = '#FFFFFF';
  },
  computed: {
    backgroundStyle() {
      // The sibling steps inline `require('images/login_background.png')` in
      // the template; that Webpacker-era `require` only exists after the
      // vite require-loader transform, so guard it for test environments.
      try {
        return {
          backgroundImage: `url(${require('images/login_background.png')})`,
        };
      } catch (e) {
        return {};
      }
    },
    isPhonePlausible() {
      return this.phone.replace(/\D/g, '').length >= 7;
    },
  },
  methods: {
    skip() {
      if (this.submitting) return;
      window.location.href = '/clients';
    },
    async submit() {
      if (!this.isPhonePlausible || this.submitting) return;
      this.submitting = true;
      try {
        const { data } = await this.axiosInstance.post(
          `${this.organizationUrl}signup_phone`,
          {
            phone: this.phoneCode + this.phone,
          },
        );
        if (data.success) {
          window.location.href = '/clients';
        } else {
          this.$toast.show(
            data.error || "We couldn't send the link. Please check your number and try again.",
            this.toasted_options.error,
          );
          this.submitting = false;
        }
      } catch (error) {
        this.$toast.show(
          "We couldn't send the link. Please try again.",
          this.toasted_options.error,
        );
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
/* The shared .story-background phone visual is sized for the old split
   layout (533x400); scale it down to sit inside the centered card. */
.send-number-visual .story-background {
  height: 280px;
  width: 210px;
  background-size: contain;
}

.phone-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
